import lineItemsModel from './lineItemsModel';


const purchaseModel = function googleAnalyticsPurchaseModel(order) {
  const {
    items: {
      items,
    },
    orderNumber,
    totals: {
      grandTotal,
      totalTax,
      totalShippingCost,
    },
  } = order;

  return {
    event: 'purchase',
    ecommerce: {
      transaction_id: orderNumber,
      value: parseFloat(grandTotal.replace('$', '')),
      tax: parseFloat(totalTax.replace('$', '')),
      shipping: parseFloat(totalShippingCost === 'Free' ? '0.00' : totalShippingCost.replace('$', '')),
      currency: 'USD',
      items: lineItemsModel(items, { affiliation: 'Marketplace' }, true),
    },
  };
};

export default purchaseModel;
